import type { Fallacy } from "./types";
import { createStory } from "./types";

export const falseBalance: Fallacy = {
    id: "false-balance",
    name: "False Balance",
    emoji: "⚖️",
    category: "Jebakan Digital",
    description:
      "Menyajikan dua sisi seolah **sama bobotnya**, padahal satu didukung konsensus ilmiah dan lainnya **pseudoscience tanpa bukti**.",
    tldr: "Bukan semua 'sisi' punya bobot yang sama — jangan samakan sains dengan hoaks.",
    detail:
      "False Balance terjadi ketika seseorang **memperlakukan dua posisi seolah-olah sama validnya**, padahal satu didukung bukti ilmiah yang sangat kuat dan satu lagi tidak.\n\nDi media sosial, ini sering muncul sebagai: 'Kan kita harus dengar kedua sisi dong!' Kedengarannya bijak, tapi **sebenarnya menyesatkan**.\n\nKenapa ini berbahaya? Karena memberikan **platform yang sama kepada pseudoscience** membuat publik mengira topik tersebut masih diperdebatkan di kalangan ahli, padahal tidak.\n\nCara mengenali: Tanyakan — **apakah kedua sisi ini benar-benar punya bobot bukti yang sama?** Atau salah satu didukung konsensus ilmiah sementara sisi lain hanya opini minoritas?",
    story: createStory("False Balance", "⚖️", {
      hook: {
        title: "\"Harus dengar kedua sisi dong!\"",
        body: "Kedengerannya bijak. Tapi kalau satu sisi sains dan satu sisi hoaks... emang harus disamain?",
      },
      convo: {
        claim: "97% ilmuwan sepakat perubahan iklim itu nyata dan disebabkan aktivitas manusia. Tapi katanya **kita harus dengar kedua sisi biar adil** — padahal \"sisi lain\" itu cuma 3% tanpa konsensus.",
        response: "Bukan semua \"sisi\" punya bobot sama. **3% bukan penyeimbang 97%.**",
      },
      reveal: {
        body: "Menyajikan dua sisi seolah **sama bobotnya**, padahal satu didukung konsensus ilmiah dan satu lagi **pseudoscience tanpa bukti**.",
      },
      insight: {
        title: "Kenapa bahaya?",
        body: "Ngasih panggung yang sama ke pseudoscience bikin publik ngira topik itu **masih diperdebatkan ahli**, padahal udah settled.",
      },
      engagement: {
        title: "Topik apa yang paling sering di-false balance-in?",
        body: "Vaksin, flat earth, atau yang lain? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["appeal-to-authority", "cherry-picking", "hasty-generalization"],
  };
